module.exports = __webpack_public_path__ + "static/media/skuldar.33220ccd.mp3";